import React from 'react'
import classnames from 'classnames/bind'
import css from './styles.module.scss'

const cx = classnames.bind(css)

const InputNumber = ({
  value,
  onIncrement,
  onDecrement,
  onChange,
  incrementLabel,
  decrementLabel,
  ariaLabelledBy,
  ...rest
}) => {
  return (
    <div className={css.InputNumber}>
      <fieldset aria-labelledby={ariaLabelledBy} className={css.inputGroup}>
        <button
          type="button"
          className={cx(css.buttonMinus, value > 1 ? css.buttonPlus : '')}
          aria-label={decrementLabel}
          onClick={() => onDecrement(value)}
          disabled={value === 1}
        >
          <svg
            width="14"
            height="3"
            viewBox="0 0 14 3"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13.25 1.5C13.25 1.69891 13.171 1.88968 13.0303 2.03033C12.8897 2.17098 12.6989 2.25 12.5 2.25H1.5C1.30109 2.25 1.11032 2.17098 0.96967 2.03033C0.829018 1.88968 0.75 1.69891 0.75 1.5C0.75 1.30109 0.829018 1.11032 0.96967 0.96967C1.11032 0.829018 1.30109 0.75 1.5 0.75H12.5C12.6989 0.75 12.8897 0.829018 13.0303 0.96967C13.171 1.11032 13.25 1.30109 13.25 1.5Z"
              fill="#666687"
            />
          </svg>
        </button>
        <input
          onError={(e) => console.error(e)}
          type="number"
          step={1}
          max="999999"
          value={value}
          min="1"
          className={css.quantityField}
          onChange={(e) => onChange(Number(e.target.value))}
          {...rest}
        />
        <button
          type="button"
          className={cx(css.buttonMinus, css.buttonPlus)}
          onClick={() => onIncrement(value)}
          aria-label={incrementLabel}
        >
          <svg
            width="14"
            height="13"
            viewBox="0 0 14 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13.25 6.5C13.25 6.69891 13.171 6.88968 13.0303 7.03033C12.8897 7.17098 12.6989 7.25 12.5 7.25H7.75V12C7.75 12.1989 7.67098 12.3897 7.53033 12.5303C7.38968 12.671 7.19891 12.75 7 12.75C6.80109 12.75 6.61032 12.671 6.46967 12.5303C6.32902 12.3897 6.25 12.1989 6.25 12V7.25H1.5C1.30109 7.25 1.11032 7.17098 0.96967 7.03033C0.829018 6.88968 0.75 6.69891 0.75 6.5C0.75 6.30109 0.829018 6.11032 0.96967 5.96967C1.11032 5.82902 1.30109 5.75 1.5 5.75H6.25V1C6.25 0.801088 6.32902 0.610322 6.46967 0.46967C6.61032 0.329018 6.80109 0.25 7 0.25C7.19891 0.25 7.38968 0.329018 7.53033 0.46967C7.67098 0.610322 7.75 0.801088 7.75 1V5.75H12.5C12.6989 5.75 12.8897 5.82902 13.0303 5.96967C13.171 6.11032 13.25 6.30109 13.25 6.5Z"
              fill="#666687"
            />
          </svg>
        </button>
      </fieldset>
    </div>
  )
}

InputNumber.defaultProps = {}

export default InputNumber
